<template>
    <div class="xl:grid md:grid md:grid-cols-2 xl:grid-cols-3 lg:mx-auto mt-1">
        <span v-for="result in results" :key="result.id" :class="result.points > 0 ? '' : 'hidden'">
            <span class="w-content mx-1 flex">
                <result :result="result"/>
            </span>
        </span>
    </div>

    <div class="w-full border border-solid border-gray-400 mb-3 mt-1"></div>

    <div class="xl:grid xl:grid-cols-3 md:grid md:grid-cols-2 lg:mx-auto mt-1">
        <span v-for="result in results" :key="result.id" :class="result.points === 0 ? '' : 'hidden'"> 
            <span class="w-content mx-1 flex">
                <result :result="result"/>
            </span>
        </span>
    </div>
</template>

<script>
    import Result from '@/Global/Play/Partials/Result'

    export default {

        props: {
            results: {
                type: Object,
                default: {}
            }
        }

    }
</script>
